import React, { useEffect, useRef, useState } from "react";
import Calendar from "../Calendar";
import dayjs from "dayjs";
import { CancerCoverBasicInfo } from "src/routes";
import calendarIcon from "@assets/icon/calendar-grey.svg";
import { styled } from "@linaria/react";
import { themeDefault } from "src/theme";
import { SCREEN_SIZE } from "@static/screen-size";

interface IProps {
  label?: string;
  date?: "" | dayjs.Dayjs|undefined;
  errorMsg?: string;
  showError?: boolean,
  disabled?:boolean,
  onChangeDate: (e: dayjs.Dayjs) => void;
}
const regex = new RegExp("^[0-9]{0,2}-{0,1}[0-9]{0,2}-{0,1}[0-9]{0,4}$");
document.body.style.background = "light grey";
function DatePicker({ label, errorMsg, onChangeDate,disabled = false, ...prop }: IProps) {
  const [date, setDate] = useState<any>(prop.date);
  const [showCal, setShowCal] = useState(false);
  const [isValid, setIsValid] = useState(true);
  const inputField = useRef<HTMLInputElement>(null)
  const handleDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let value = e.target.value;
    setDate((prev: any) => {
      if (regex.test(value)) {
        if ([2, 5].includes(value.length) && prev?.length < value.length) {
          value += "-";

          return value;
        } else {
          return value;
        }
      }

      return prev;
    });
  };
  const dateSplit =
    typeof date === "string"
      ? date.split("-")
      : date.format("DD-MM-YYYY").split("-");
  let formatedDate = `${dateSplit[1]}-${dateSplit[0]}-${dateSplit[2]}`;
  useEffect(() => {
    CancerCoverBasicInfo.preload();
  }, []);
  useEffect(()=>{
    onChangeDate(date)
  },[date])

  useEffect(() => {
    function resizeHandler() {
      if (inputField.current) {
        inputField.current.readOnly = window.innerWidth < SCREEN_SIZE.mobilesUp;
      }
    }
    window.addEventListener("resize", resizeHandler);
    return () => {
      window.removeEventListener("resize", resizeHandler);
    };
  }, []);
  return (
    <>
    <div>
      <Label 
      isDisabled={disabled}
      isValid={isValid} showError={!!prop.showError}>
        <label>
          <p className="labelText">{label}</p>
          <input
            autoComplete="off"
            ref={inputField}
            disabled={disabled}
            type="text"
            id="date-picker-input"
            value={(document.activeElement?.id === "date-picker"
              ? date
              : typeof date?.format === "function"
              ? date.format("DD MMM YYYY")
              : date
            )?.toUpperCase()}
            placeholder="DD MMM YYYY"
            onChange={handleDateChange}
            onClick={(e)=>{
              if((e.target as HTMLInputElement).readOnly){
              setShowCal(true)}
            }}
            onFocus={(e) => {
              // setShowCal(true);
              const dateNew = dayjs(
                typeof date?.format === "function"
                  ? date?.format("MM-DD-YYYY")
                  : date
              );
              const formatedDate = dateNew.format("DD-MM-YYYY");
              if (
                !/^[0-9]{1,2}(-|\/)[0-9]{1,2}(-|\/)[0-9]{4}$/.test(
                  typeof date === "string" ? date : formatedDate
                )
              ) {
                return;
              }
              if (!dateNew.isValid()) {
                setDate("");
                return;
              } else {
                setIsValid(true);
              }
              setDate(formatedDate);
            }}
            onBlur={() => {
              setDate((prev: any) => {
                let val;
                if (typeof prev?.format === "function") {
                  val = prev?.format("MM-DD-YYYY");
                } else {
                  val = prev.split("-");
                  val = `${val[1]}-${val[0]}-${val[2]}`;
                }
                const dateNew = dayjs(val);
                if (dateNew.isValid()) {
                  setIsValid(true);
                  return dateNew;
                }
                setIsValid(false);
                return prev;
              });
              // setShowCal(false)
            }}
          />
        </label>
        <button
          className="cal-icon"
          onClick={() => {
            if(disabled){
              return;
            }
            setShowCal((prev) => !prev);
          }}
        >
          <img src={calendarIcon} alt="calendar sheet" />
        </button>
        {showCal && (
          <div id="calendar">
            <Calendar
              currentDate={
                document.activeElement?.id === "date-picker"
                  ? formatedDate
                  : dayjs(formatedDate)
              }
              showCal={showCal}
              setShowCal={setShowCal}
              onSelectDate={(d) => {
                setDate(d as dayjs.Dayjs);
                setShowCal(false);
                setIsValid(true)
              }}
            />
          </div>
        )}

      </Label>
     
      {(!isValid ||prop.showError )&& (
          <ErrorTag>
            {errorMsg }
          </ErrorTag>
        )}

        
        </div>
    </>
  );
}

export default DatePicker;

const Label = styled.div<{ isValid: boolean, showError: boolean, isDisabled:boolean}>`
  .labelText{
    font-size: 14px;
    font-weight: 500;
    line-height: 19.6px;
    letter-spacing: calc(0.015 * 14px);
    margin-bottom: 16px;
  }
  input {
    background-color: transparent;
  }
  position: relative;
  border-bottom: 1px solid
    ${(prop) => ((!prop.showError) ? themeDefault.colors.grey[1000] : "#990005")} ;
  width: 100%;
  display: flex;
  max-width: 664px;
  transition: border 0.2s linear;
  label {
    width: 100%;
  }
  &:focus-within {
    /* border-bottom: 2px solid */
  }
  #date-picker-input,
  #date-picker-input:focus {
    cursor:${prop=>prop.isDisabled? "not-allowed":"pointer"};
    border: none;
    outline: none;
    flex: 1;
    width: 100%;
    font-size: 14px;
    font-weight: 500;
    line-height: 22.4px;
  }
  .cal-icon > img {
    width: 24px;
    aspect-ratio: 1/1;
  }
  #calendar {
    position: absolute;
    top: 50px;
    right: 0px;
    & > div {
      border-radius: 16px;
    }
  }
  .cal-icon {
    background-color: transparent;
    border: none;
    cursor:${prop=>prop.isDisabled? "not-allowed":"pointer"};
    display: flex;
    align-self: self-end;
    margin-bottom: 5px;
  }
@media screen and (min-width: ${SCREEN_SIZE.mobilesUp}px) {
  #calendar {
    position: absolute;
    top: 50px;
    right: 0px;
    & > div {
      border-radius: 16px;
    }
  }
}
@media screen and ((pointer: coarse) ) {
  #calendar {
    position: absolute;
    top: 50px;
    right: 0px;
    & > div {
      border-radius: 16px;
    }
  }
}
`;

const ErrorTag = styled.p `
  color: #990005;
  font-size: 12px;
  font-weight: 600;
  line-height: 16.8px;
`
